module.exports = __webpack_public_path__ + "static/condo_design-1-30a68b72d9a747bc6725a0de20ed6364.jpg";